module.exports = __webpack_public_path__ + "4551b4dc7864a8ed953d5b053c15854f.pdf";